module.exports = __webpack_public_path__ + "img/abc-sport.387cb0a3.png";